import { Box, Typography } from "@mui/material";
import DataContent from "../../../components/DataContent";
import { DataCodeEnum } from "../../../constants/enum";
import PageContentEditor from "../../../components/PageContentEditor";

const MasterNumbers = () => {
  return (
    <Box m={2}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          color="primary"
          variant="h5"
          sx={{
            fontWeight: "bold",
          }}
          gutterBottom
        >
          Master Numbers
        </Typography>
      </Box>
      <Box
        sx={{
          height: "calc(100vh - 60px)",
        }}
      >
        <PageContentEditor
          dataCode={DataCodeEnum.MASTER_NUMBERS}
          dataName={"Master Numbers?"}
        />
      </Box>
    </Box>
  );
};

export default MasterNumbers;
